module.exports = __webpack_public_path__ + "img/salon_hour_setting.5d81fcbb.svg";